import { gql } from '@apollo/client';

export const GET_FIRE_POLICY_VAR_DETAILS = gql`
  query getFirePolicyVarDetails {
    fireQuote @client
    selectedIntermediary @client
  }
`;

export const GET_FIRE_UPLOAD_POLICY_VAR_DETAILS = gql`
  query getFireUploadPolicyVarDetails {
    fireQuoteUploadDocs @client {
      documentDetails
    }
  }
`;
export const CUSTOMER_DROPDOWN_DETAILS = gql`
  query customerDropdownDetailsDetails {
    organisationList {
      code
      value
    }
    salutationList {
      code
      value
      gender
    }
    genderList {
      code
      value
    }
  }
`;
export const UW_QUOTE_APPROVAL = gql`
  mutation fireQuoteUWApproval($input: FireUWQuoteInput) {
    fireQuoteUWApproval(input: $input) {
      quoteNumber
      message
      quoteStatus
    }
  }
`;
export const DOCUMENT_STATIC_DATA = gql`
  query documentExtensions {
    documentExtensions {
      code
      value
    }
    docFileSizeLimit {
      code
      value
    }
    docDescCharacterLimit {
      code
      value
    }
  }
`;
export const INTERMEDIARY_LIST = gql`
  query IntermediaryList {
    myIntermediaries {
      intermediaryName
      intermediaryCode
      isSelected
      businessLocations {
        code
        name
      }
    }
  }
`;

export const SEARCH_CUSTOMERS = gql`
  query searchCustomers($filter: CustomerFilter) {
    _customer_meta(filter: $filter) {
      resultCount
      maxRow
      infoMessages
      metaMessage {
        type
        header
        message
      }
    }
    customers(filter: $filter) {
      cust_type {
        code
        value
      }
      cust_number
      indv_detail {
        full_name
      }
      org_detail {
        org_name
      }
      contact {
        email
        mobile
      }
      permanent_address {
        location
      }
    }
  }
`;
export const LOOKUP_FIELDUSER = gql`
  query lookupFieldUser($filter: UserSearchFilter) {
    associatedEntityLookup(filter: $filter) {
      fieldUserName
    }
  }
`;

export const GET_CUSTOMER_TYPE_DOMAIN = gql`
  query getCustomerTypeDomain {
    customerTypeList {
      code
      value
    }
  }
`;

export const PRODUCT_TYPE_LIST = gql`
  query productTypeList {
    lobProductList {
      lob_name
      lob_code
      products {
        product_name
        product_code
        product_types {
          code
          value
        }
        linkTo
      }
    }
  }
`;

export const PINCODE_LOOKUP = gql`
  query customerAddress($filter: PincodeFilter) {
    pincodeWithEqZone(filter: $filter) {
      cityCode
      city
      districtCode
      district
      pinCode
      pinCodeLocality
      stateCode
      state
      countryCode
      country
      eqZone
      locationCode
      locationDesc
    }
  }
`;

export const CHARACTER_LIMIT_LIST = gql`
  query characterLimitList {
    characterLimitList {
      code
      value
    }
  }
`;

export const GET_DATE_TIME = gql`
  query getDateTime {
    datetimeValue {
      time
      date
    }
  }
`;

export const CUSTOMER_DROPDOWN_QUERIES = gql`
  query customerDetails(
    $productCode: StrictNumber
    $domainCode: String
  ) {
    PRD_policyPeriod(productCode: $productCode) {
      code
      value
    }
    PRD_typeOfPolicy(productCode: $productCode) {
      code
      value
    }
    PRD_CustomerTypeList(productCode: $productCode) {
      code
      value
    }
    PRD_claimsInPreviousYear(productCode: $productCode) {
      code
      value
    }
    dayRange(productCode: $productCode, domainCode: $domainCode) {
      minDay
      maxDay
    }
    PRD_BusinessSumInsured(productCode: $productCode) {
      code
      value
    }
  }
`;

export const RISK_DROPDOWN_QUERIES = gql`
  query riskDropDownDetails($productCode: StrictNumber) {
    
    PRD_distanceFromWaterbody(productCode: $productCode) {
      code
      value
    }
    PRD_securityProvisions(productCode: $productCode) {
      code
      value
    }
    PRD_occupancy(productCode: $productCode) {
      code
      value
      occupancySection
      occupancyRate
      riskCode
      rateCode
      riskGrade
      riskGradeDefinition
      riskPreference
      gicClass
      stfiRate
      rsmdRate
    }
    PRD_fireExtinguisherApplisDtls(productCode: $productCode) {
      code
      value
    }
    PRD_MaxLocationSI(productCode: $productCode) {
      code
      value
    }
    PRD_maxFloaterLocLimit(productCode: $productCode) {
      code
      value
    }
    PRD_MaxStockSIatOneLocation(productCode: $productCode) {
      code
      value
    }
    PRD_previousClaimExperience(productCode: $productCode) {
      code
      value
    }
    
  }
`;

export const GET_SELECTED_INTERMEDIARY = gql`
  query getSelectedIntermediary {
    selectedIntermediary @client
  }
`;

export const CALC_PREMIUM_QUOTE_FIRE_SA = gql`
  query calculatePremiumQuoteFireSA($input: FireCalcPremiumInputSA) {
    fireCalculatePremiumSA(input: $input) {
      locationNetPremium
      locationGST
      locationTotalPremium
      basicRate
      warningMsg
    }
  }
`;

export const SAVE_QUOTE_FIRE = gql`
  mutation saveQuote($input: FireQuoteInputSA) {
    saveQuoteFireSA(input: $input) {
      quoteCreationDate
      quoteNumber
      status
      stageIndex
      Msg
    }
  }
`;

export const SAVE_LOCATION_FIRE = gql`
  mutation saveLocation($input: FireRiskLocationInputSA) {
    saveLocationSA(input: $input) {
      riskLocationID
      successMsg
      failMsg
      finalisedPremium {
        locNetPremium
        locTotalPremium
        locGST
        stampDuty
      }
    }
  }
`;

export const REMOVE_RISK_LOCATION = gql`
  mutation removeRiskLocation($input: FireRemoveLocInput) {
    removeLocation(input: $input) {
      riskLocationID
      successMsg
      failMsg
      finalisedPremium {
        locNetPremium
        locTotalPremium
        locGST
       
      }
    }
  }
`;

export const SEND_QUOTE_EMAIL_FIRE = gql`
  mutation sendQuoteEmailFireSA(
    $input: FireQuoteInputSA
    $email: String
    $quoteNumber: String
    $ccEmailIds: [String]
  ) {
    sendQuoteEmailFireSA(
      input: $input
      email: $email
      quoteNumber: $quoteNumber
      ccEmailIds: $ccEmailIds
    ) {
      message
    }
  }
`;

export const SEND_QUOTE_SMS_FIRE = gql`
  mutation sendQuoteSMSFireSA(
    $input: FireQuoteInputSA
    $mobile: String
    $quoteNumber: String
    $alternateMobileNos: [String]
    $whatsappNo: String
    $modes: [String]
  ) {
    sendQuoteSMSFireSA(
      input: $input
      mobile: $mobile
      quoteNumber: $quoteNumber
      alternateMobileNos: $alternateMobileNos
      whatsappNo: $whatsappNo
      modes: $modes
    ) {
      message
    }
  }
`;

export const SEND_QUOTE_PDF_FIRE = gql`
  mutation sendQuotePDFFireSA(
    $input: FireQuoteInputSA
    $quoteNumber: String
  ) {
    sendQuotePDFFireSA(input: $input, quoteNumber: $quoteNumber) {
      base64Pdf
    }
  }
`;
export const Geographical_Area_list = gql`
query geographicallocation($productCode: StrictNumber){
  PRD_geographicalArea(productCode: $productCode){
      code 
     value
  }
  
}
`;
// export const risk_dropdown_SA = gql`
// query occupancysearch($productCode: StrictNumber){
//   PRD_occupancySA(productCode: $productCode) {
//     code
//     value
//   }
// }
// `;
export const MOBILE_NUMBER_STARTING_WITH = gql`
  query mobileNumberStartingWith {
    mobileNumberStartingWith {
      code
      value
    }
  }
`;
export const GET_FIRE_QUOTE_DOCS = gql`
  query documentsInfo {
    documentListFire {
      code
      value
    }
    documentExtensions {
      code
      value
    }
    docFileSizeLimit {
      code
      value
    }
    docDescCharacterLimit {
      code
      value
    }
  }
`;
export const GET_DEFAULT_CLAUSES = gql`
  query getDefaultClauses(
    $input: ClauseConditionExclusionWarrentyInput
  ) {
    getDefaultClauses(input: $input) {
      clauseCode
      clauseDescription
      clauseNumber
      default
      txtClauseType
      description
    }
  }
`;
export const GET_DEFAULT_CONDITIONS = gql`
  query getDefaultConditions(
    $input: ClauseConditionExclusionWarrentyInput
  ) {
    getDefaultConditions(input: $input) {
      conditionCode
      conditionShortDescription
      txtConditionNumber
      txtDefault
      txtConditionType
      description
    }
  }
`;
export const GET_DEFAULT_EXCLUSIONS = gql`
  query getDefaultExclusions(
    $input: ClauseConditionExclusionWarrentyInput
  ) {
    getDefaultExclusions(input: $input) {
      exclusionCode
      exclusionShortDescription
      txtExclusionNumber
      txtDefault
      txtExclusionType
      description
    }
  }
`;
export const GET_DEFAULT_WARRANTIES = gql`
  query getDefaultWarranties(
    $input: ClauseConditionExclusionWarrentyInput
  ) {
    getDefaultWarranties(input: $input) {
      warrantyCode
      warrantyShortDescription
      txtWarrantyNumber
      txtDefault
      txtWarrantyType
      description
    }
  }
`;
export const CHECKAUTH_QUERY = gql`
  query fireCheckAuth {
    checkAuth {
      userProfileName
      authenticated
      lastLogin
      role {
        roleName
        permissions {
          resourcePermission
        }
        permissionType
      }
    }
  }
`;
export const COVER_FIRESA = gql`
  query coverListForSA($input: ApplicableCoversInputSA) {
    coverListForSA(input: $input) {
      tenure
      riskCovers {
        riskType
        covers {
          name
          index
          valAmt
          pctAmt
           stfiRate
           eqRate
           rsmdRate
           basicRate
           terrorismCover
          selected
          attributes {
            name
            value
            displayName
            fieldType
            fieldDataType
            defaultValue
            showOnScreen
            dataValues {
              code
              value
            }
            siPercentage
          }
        }
      }
    }
  }
`;
export const PINCODE_EXCLUSION_LIST = gql`
   query getPincodeExclList( $productCode: String){
    getPincodeExclList(productCode: $productCode){
        id
        productCode
        pincodeDetails {
      pincode
          cityTownVillage
          district
          state 
    }
      }
   }
`;
export const LOB_PRODUCT_LIST = gql`
  query lobProductList {
    lobProductList {
      lob_name
      lob_code
      products {
        product_name
        product_code
        product_types {
          code
          value
        }
        linkTo
      }
    }
  }
`;
export const DATE_RANGE = gql`
  query dateRange($type: String){
    dateRange(type: $type) {
      min
      max
    }
  }
`;
export const QUOTE_STATUS_LIST = gql`
  query {
    quoteStatusList {
      code
      value
    }
  }
`;
export const SEARCH_QUOTES = gql`
  query searchQuotes($filter: Quote) {
    searchQuotes(filter: $filter) {
      lob {
        lobCode
        lobName
      }
      product {
        productCode
        productName
      }
      quoteCreationDate
      customer {
        indv_detail {
          first_name
          surname
          full_name
          middle_name
        }
        org_detail {
          org_name
        }
        contact {
          mobile
          email
        }
      }
      quoteNumber
      quotationType
      quoteStatus
      members {
        relationship
        gender
        age
      }
      location {
        city
        state
        zone
      }
      cover {
        type
        tenure
        sumInsured
      }
      plans {
        name
        premium {
          totalPremium
        }
      }
    }
    _quote_meta(filter: $filter) {
      maxRow
      resultCount
      infoMessages
      metaMessage {
        type
        header
        message
      }
    }
  }
`;
export const VIEW_QUOTE_FIRE_SA = gql`
  query viewQuoteFireSA($input: FireViewQuoteInput) {
    viewQuoteFireSA(input: $input) {
      quoteNumber
      quoteCreationDate
      status
      proposalNumber
      stageIndex
      otherDetails 
      { 
        premisesRentedOut
        ownerOccupant
      }
      loadingAndDiscount 
      { 
        discountPercentage
         loadingPercentage 
         }
      district
      pincode
      state
      customerDetails
          {
            customerType{
            code
            value
            },
            orgInsuredName
            firstName
            middleName
            lastName
          }
      customer {
        bank_detail {
          ifsc_code
          branch_name
          name
          acc_holder
          micr_code
          acc_number
        }
        cust_number
        cust_ref_number
        cust_type {
          code
          value
        }
        indv_detail {
          title {
            code
            value
          }
          gender {
            code
            value
          }
          occupation {
            code
            value
          }
          nationality {
            code
            value
          }
          marital_status {
            code
            value
          }
          first_name
          surname
          middle_name
          full_name
          date_of_birth
          id_proof_type {
            code
            value
          }
          id_proof_number
          pan_card_number
          gst_number
        }
        org_detail {
          org_name
          org_type {
            code
            value
          }
          contact_name
          reg_number
          tan_number
          gst_number
        }
        permanent_address {
          address_line1
          address_line2
          address_line3
          land_mark
          state
          district
          city
          pin_code
        }
        communication_address {
          address_line1
          address_line2
          address_line3
          land_mark
          city
          district
          state
          pin_code
        }
        comm_equal_perm
        contact {
          mobile
          email
          fax_number
          telephone
          alt_telephone
          alt_mobile
        }
      }
      lob {
        lobCode
        lobName
      }
      product {
        productCode
        productName
      }
      businessOfInsured
      prevClaimExpDtls {
        anyPrevClaimsExp
        prevClaimExpDesc
      }
      policyType
      tenure {
        code
        value
      }
      policyStartDate
      policyExpiryDate
      geographicalArea
      clauses {
        default
        userDefined
      }
      exclusions {
        default
        userDefined
      }
      warranties {
        default
        userDefined
      }
      conditions {
        default
        userDefined
      }
      uploadedDocuments {
        documentType {
          code
          value
        }
        documentName
        documentSize
        base64EncodedDoc
      }
      underwriterComment
      riskCovers {
        riskType
        covers {
          name
          index
          selected
          attributes {
            name
            value
            displayName
            fieldType
            fieldDataType
            defaultValue
            showOnScreen
            dataValues {
              code
              value
            }
          }
        }
      }
      riskLocations {
        riskLocationID
        occupancyCodeValue {
          code
          value
          occupancySection
          occupancyRate
          riskCode
          rateCode
          riskGrade
          riskGradeDefinition
          riskPreference
          gicClass
          stfiRate
          rsmdRate
        }
        riskLocAddress {
          address_line1
          pin_code
          state
          city
          district
          eqZone
          locationCode
        }
        costOfConstruction
        carpetArea
        ratePerMille
        buildingValue
        additionalStructure
        totalBuildingSI
        generalContentSI
        additionalContent
        additionalContentSI
        valuableContent
        valuableContentSI
        totalContentSI
        totalSumInsured
        loadingPct
        discountPct
        premium {
          locationNetPremium
          locationGST
          locationTotalPremium
        }
      }
      intermediaryDetails {
        code
        location
        fieldUserCode
        fieldUserName
      }
      finalisedPremium {
        locNetPremium
        locGST
        locTotalPremium
        basicRate
      }
    }
  }
`;
export const COST_OF_CONSTRUCTION = gql`
  query getCostOfConstruction($input: cocMasterInput){
    PRD_costOfConstruction(input: $input){
      defaultValue
      minCOC
      maxCOC
    }
  }
`;
